import { Component, OnInit, inject } from '@angular/core';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { DomSanitizer } from '@angular/platform-browser';
import { KycDocumentType } from '../../../core/models/kyc.model';
import { StringHelper } from '../../../core/helpers/strings.helper';

@Component({
    selector: 'app-document-sample-modal',
    templateUrl: './document-sample-modal.component.html',
    styleUrls: ['./document-sample-modal.component.scss'],
})
export class DocumentSampleModalComponent implements OnInit {
    currentView: KycDocumentType;
    KycDocumentType = KycDocumentType;
    document: any;
    title: string;
    sample: any;
    isPdf: boolean;
    readonly Base64prefix = 'data:image/png;base64,';
    readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

    constructor(private modal: NzModalRef, private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
        this.currentView = this.modal.componentInstance?.data;
        this.sample = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.Base64prefix} ${this.modal.componentInstance.data?.sample}`);
        this.document = this.modal.componentInstance.data?.document;
        this.title = this.modal.componentInstance.data?.title || this.modal.componentInstance.data?.value;
        this.isPdf = this.modal.componentInstance.data?.isPdf;
        this.currentView = this.isPdf ? KycDocumentType.PDF : this.currentView;
        if (this.isPdf) {
            this.document = StringHelper.createObjectURL(this.document);
        }
    }

    dismiss() {
        this.modal.componentInstance.callback();
    }

    setDocumentUrl() {}
}
